import { styled, Text } from "tamagui";

export const FormTitle = styled(Text, {
  name: "FormTitle",
  fontFamily: "$subtitle",
  fontSize: "$6",
  fontWeight: "$6",
  lineHeight: "$6",
  $gtSm: {
    fontSize: "$7",
    lineHeight: "$7",
  },
});
